import React from 'react';

import {
  ItemCardContainer,
  ItemCardImage,
  ItemName,
  ItemPrice,
  ItemInfoContainer,
} from './styles';

import ItemQuantitySelector from './components/ItemQuantitySelector';

export default function ItemCard({
  itemData,
  selectedQuantity,
  setSelectedQuantity,
}) {
  return (
    <ItemCardContainer>
      <ItemCardImage src={itemData.imageUrl} />
      <ItemInfoContainer>
        <ItemName>{itemData.name}</ItemName>
        <ItemPrice>{`${itemData.quantity}x R$${itemData.price}`}</ItemPrice>
      </ItemInfoContainer>
      <ItemQuantitySelector
        quantity={itemData.quantity}
        selected={selectedQuantity}
        onChange={setSelectedQuantity}
      />
    </ItemCardContainer>
  );
}
